

let _AUTH_SERVICE_URL
let _ADMIN_SERVIE_URL
let _APP_URL
let _B2C_URL
let _ADMIN_SYNC_URL
let _B2C_CUSTOMER_URL
let _CURRENT_ENV = 'SIT'

export const API_URL = `https://api-customer-portal.tes-amm.com/v1`;
export const SIT_URL = `https://api-sit-portal.tes-amm.com/v1` || `http://tes-gdc-customerportal-dev-564908650.eu-central-1.elb.amazonaws.com`;
export const UAT_URL = `https://api-uat-portal.tes-amm.com/v1` || `http://tes-gdc-customerPortal-Uat-582162864.eu-central-1.elb.amazonaws.com`;

export const LOCAL_AUTH_URL = `http://localhost:7034`;
// _APP_URL = `http://sit-portal.tes-amm.com`;

let ENV_TYPES = {
    LOCAL: 'local',
    SIT: 'sit',
    PRODUCTION: 'production',
    UAT: 'uat'
}

const API_REQUESTS = {
    LOGIN: 'auth/backend/login',
    USER_ROLE_URL: '/userroles/fetchUserRoleAndRights',
    PROCESSLIST_URL: '/requestDetails',
    CLIENT_URL: '/clients',
    COUNTRY_URL: '/Countries',
    REQUEST_TYPE_URL: '/RequestTypes',
    REQUEST_STAGE_URL: '/RequestStages',
    REQUEST_STAGE_INPUT_FIELD_URL: '/RequestStageInputs',
    REQUEST_STAGE_STATUS_URL: '/RequestStageStatuses',
    PROGRAM_URL: '/programs',
    PACKAGING_URL: '/packagings',
    PACKAGING_CODE: '/packingCodeCarriers',
    PROGRAM_COUNTRIES: '/programCountries',
    GET_PROGRAM_PACK_URL: '/packingsProgram',
    PROGRAM_PACK_URL: '/packingsProgram',
    PROGRAM_RECYCLING_PARNTER_URL: '/recyclingPartnersProgram',
    CLIENT_PROCESS_PARNTER: '/ClientRecyclingPartners',
    PROGRAM_CARRIER_URL: '/programCarriers',
    PROGRAM_COMPANY_URL: '/programCompanies',
    PORTAL_COMPANIES:'/portal/portal-companies',
    COMPANY_CONTACTS:'/portal/company-contacts',
    PROGRAM_BRANDS_URL: '/programBrands',
    PROGRAM_DOCUMENT_TYPE_URL: '/programDocumentTypes',
    CLIENT_LANGUAGES: '/clientCultures',
    CLIENT_PACKINGS: '/clientPackagings',
    CLIENT_ASSETS: '/ClientAssets',
    CLIENT_ADDITIONAL_INFO: '/ClientAdditionalInfo',
    CARRIER_URL: '/Carriers',
    BOX_URL: '/Boxes',
    BRAND_URL: '/Brands',
    LABEL_URL: '/labels',
    MANUFACTURER_URL: '/manufacturers',
    PROGRAM_BOX_URL: '/programBoxes',
    PROGRAM_LABEL_URL: '/programLabel',
    PROGRAM_COUNTRY_URL: '/programCountries',
    CURRENCY_URL: '/currencies',
    REGION_URL: '/regions',
    TRUCK_URL: '/TruckLists',
    MODELS_URL: '/models',
    POWERBI_ACCESS_URL: '/pbiaccesses',
    POWERBI_REPORT_URL: '/pbireports',
    POWERBI_REPORT_USER_URL: '/pbireportusers',
    PORTAL_STORYBOARD_URL: '/dacp-dashboards',
    RELEASE_VERSION_URL: '/releaseNotes',
    UNIT_MEASUREMENT_TYPE: '/unitConversions',
    USER_CONFIGURATION_URL: '/userConfigurations',
    SEARCH_FILTER_URL: '/searchFilters',
    DOCUMENT_TYPE_URL: '/documentTypes',
    PROGRAM_REQUEST_TYPES: '/ProgramWithRequestTypes',
    PROGRAM_REQUEST_STAGES: '/programWithStageSequence',
    REQUEST_STAGES: '/RequestStages',
    PROGRAM_REQUEST_STAGE_INPUTS: '/ProgramStageInputFields',
    CHANGE_LOG_SETTINGS:'/ChangeLogSettings',
    PROGRAM_LANGUAGES_URL: '/programCultures',
    PROGRAM_PACKING_TYPES: '/programPackingTypes',
    HOLIDAY_URL: '/Holidays',
    STANDARD_PROFILES: '/StandardProfiles',
    COUNTRY_PROFILES: '/CountryProfiles',
    USER_SERVICE_GROUPS: '/UserServiceGroups',
    PORTAL_TYPE_URL: '/PortalTypes',
    PORTAL_CATEGORY_URL: '/PortalCategories',
    PROGRAM_IP_WHITELIST: '/IPWhitelistRoutes',

    // program stage status Information
    PROGRAM_REQUEST_STAGE_STATUS: '/portalStageStatuses',
    PROGRAM_ASSETS: '/AssetsPrograms',
    PROGRAM_ADDITIONAL_INFO: '/ProgramAdditionalInfo',
    ALL_REQUEST_TYPES_URL: '/RequestTypes',
    CULTURES: '/cultures',
    STATUSES: '/Statuses',
    PROGRAMS: '/Programs',
    ASSETS_STATUS: '/assetstatuses',
    ASSETS: '/assets',
    ASSETS_TYPE: '/AssetTypes',
    RECYCLING_PARTNER: '/RecyclingPartners',
    TAKE_BACK_OPTIONS: '/TakeBackOptions',
    REQUEST_STATUSES_URL: '/RequestStatusMaps',
    REQUEST_STATUSES_PROGRESS_URL: '/RequestStatusProgresses',
    SETTINGS:'/CommonSettings',
    DIMENSIONS_URL:'/PackageDimensions',
    //authmanager urls
    BACKEND_USER_SIGNUP: '/backend/signup',
    INIT_FORGOT_PSWD: '/backend/forgotPassword',
    CONFIRM_FORGOT_URL: '/backend/confirmPassword',
    VALIDATE_FORGOT_PASSWORD_TOKEN_URL: '/backend/validateForgotPasswordToken',
    CHANGE_PWD_URL: '/backend/changePassword',
    UPLOAD_PORTAL_LOGO: '/portal/uploadPortalLogo',
    GET_PORTAL_LOGO: '/portal/getPortalLogoByAdmin',
    USERS: '/Users',
    USERCLOUD: '/user',
    USER_ROLES: '/userroles',
    BACKEND_USER_LOGIN: '/backend/login',
    ROLES: '/Roles',
    RIGHT_OBJECTS_URL: '/rightobjects',
    USER_FEEDBACK_URL: '/userFeedbacks',
    USER_FEEDBACK_QUESTIONS: '/PortalUserFeedbackQuestions',
    // userclients
    USER_CLIENTS_URL: '/UserClients',
    USER_PORTALS_URL: '/UserPortals',
    PORTAL_USER_COUNTRY_URL: '/PortalUserCountries',
    PORTAL_USER_COMPANY: '/PortalUserCompanies',
    REQUEST_ASSETS: '/newRequestAssets',
    REQUEST_EXCEL_ASSETS: '/assetExcels',
    //Terms & Privacy
    GET_TERMS: '/TermsAndPrivacies',
    ADD_TERMS: '/TermsAndPrivacies/createTermsAndConditions',
    ADD_PRIVACY: '/TermsAndPrivacies/createPrivacyPolicy',
    UPDATE_TERMS: '/TermsAndPrivacies/updateTermsAndConditions',
    UPDATE_PRIVACY: '/TermsAndPrivacies/updatePrivacyPolicies',
    // All Store Locations
    STORE_LOCATIONS: `/StoreLocations`,
    PROGRAM_STORE_POOLS: `/portal/createProgramPools`,
    SERVICE_TYPE: '/ServiceTypes',
    SERVICES: '/services',
    CLIENT_SERVICES: '/clientServices',

    CLIENT_PO: '/clientPO',
    // Portal USERS
    CREATE_PORTAL_USER: '/portal/signup',
    LIST_PORTAL_USERS: '/user/portalListUsers',
    GET_PORTAL_USER_BY_ID: '/user/getPortalUserInfo',
    UPDATE_PORTAL_USER: '/user/updatePortalUserInfo',
    ADDITIONAL_INFO: '/AdditionalInfo',
    ADDITIONAL_INFO_DATA: '/requestAdditionalInfos/getRequestAdditionalInfo',
    BOX_INFO: '/requestPackings/getPacking',
    EXTRA_SERVICE: '/requestServices/getService',
    UPDATE_EXTRA_SERVICE: '/requestServices/saveService',
    UPDATE_STANDARD_SERVICE:'/quoteStandardServices/saveQuoteService',
    UPDATE_STANDARD_SERVICE_EXCEL:'/assetExcels/saveService',
    QUOTE_URL: '/quoteCommunications',
    REQUEST_ADDRESS: "/requestAddresses",
    PORTAL_QRCODES: "/requestDetails",
    PORTAL_ADDITIONAL_FIELDS: "/portalAdditionalFields",
    PORTAL_ADDITIONAL_INFO: "/ProgramAdditionalInfo",
    PORTAL_COUNTRY_URL: "/ProgramCountries",
    CLIENT_SERVICE_TYPE_URL: "/clientServiceTypes",
    EVENT_KEYS: '/EventKeys',
    ASSET_QUOTATION:'/newAssetQuotationRequests',
    QUOTE_REQUEST_CONTACT:'/quoteRequestContacts',
    REQUEST_CONTACT_URL:'/requestContactS',
    EMAIL_NOTIFICATION:'/EmailNotifications',
    PORTAL_CONTACTS:'/portalContacts',
    COUNTRY_EMAIL_NOTIFICATION:'/CountryEmailNotifications',
    // List Request documents
    REQUEST_DOCS_URL: '/requestDocuments',
    USER_LOGS: '/userlogs',
    PORTAL_USER_LOGS: '/portalUserLogs',
    ASSIGN_URL: '/updateClientPOs',
    REQUEST_ADDITIONAL_FIELDS: '/requestAdditionalFields',
    REQUEST_EXCEL_DOCUMENT: '/assetExcels',
    PORTAL_MODULE_LOGS: '/portalModuleLogs',

    SYNCING: '/syncreqs',
    MANUFACTURER: '/manufacturers',
    COUNTRIES: '/Countries',

    // Pickup Assets
    GET_PICKUP_ASSETS_COUNT: '/PickupAssets/getPickupAssetsCount',
    GET_PICKUP_ASSETS: '/PickupAssets/getPickupAssets',
    SEND_CREATE_ORDER_REQUEST_URL: '/PickupAssets/raisecollectionreq',
    PROGRAM_PACKAGE: '/programPacking',
    PROGRAM_PACKAGE_GRADE: '/programPackingFeeGrade',
    ENTITY: '/Entities',
    SUPERVISOR_USER_ACCESS:'/UserSupervisors',

    //bulkupload User
    DOWNLOAD_USERS_TEMPLATE: '/user/downloadUserTemplate',
    UPLOAD_USERS_TEMPLATE: '/user/uploadUserTemplate',
    HOME_CARRIER_INFO_URL: '/homeOfficeCarrierInfos',
    RECURSIVE_REQ_URL: '/recursiveRequests',
    CARRIER_CONTACT: '/carrierContacts',

    //refresh AuthJWT token
    REFRESH_AUTH_JWT: '/refreshAuthJWT'
}

// B2C
const B2C_API_REQUESTS = {
    // REQUEST_DETAIL_URL: '/requestDetails/fetchB2CRequestByTypeId',
    REQUEST_DETAIL_URL: '/requestDetails',
    B2C_REQUEST_ASSETS: '/newRequestAssets',
    B2C_REPORTS_DOCS_URL: '/b2creportDocuments',
    B2C_ASSET_TYPE: '/assetType'
}

const env = process.env.REACT_APP_STAGE || ENV_TYPES.LOCAL || ENV_TYPES.SIT;
if (env === ENV_TYPES.LOCAL) {
    _ADMIN_SERVIE_URL = `http://localhost:7035/cpadmin`
    _ADMIN_SYNC_URL = `http://localhost:7032/sync`
    _AUTH_SERVICE_URL = `http://localhost:7034/auth`
    _B2C_CUSTOMER_URL = `http://localhost:7037/b2cadmin`
    _B2C_URL = `http://localhost:3000` // need to chahge port based on running repo
    _APP_URL = `http://localhost:3001`
} else if (env === ENV_TYPES.SIT) {
    _ADMIN_SERVIE_URL = `${SIT_URL}/cpadmin`;
    // _AUTH_SERVICE_URL = `https://api-sit-portal.tes-amm.com/v1/auth`
    _AUTH_SERVICE_URL = `${SIT_URL}/auth`
    _ADMIN_SYNC_URL = `${SIT_URL}/sync`
    _B2C_CUSTOMER_URL = `${SIT_URL}/b2cadmin`
    // _AUTH_SERVICE_URL = `http://localhost:7034/auth`
    _APP_URL = `https://sit-portal.tes-amm.com`
    _B2C_URL = `https://sit-mailback.tes-amm.com`

} else if (env === ENV_TYPES.UAT) {
    _CURRENT_ENV = 'UAT';
    _ADMIN_SERVIE_URL = `${UAT_URL}/cpadmin`
    _AUTH_SERVICE_URL = `${UAT_URL}/auth`
    _ADMIN_SYNC_URL = `${UAT_URL}/sync`
    _B2C_CUSTOMER_URL = `${UAT_URL}/b2cadmin`
    _APP_URL = `https://uat-portal.tes-amm.com`
    _B2C_URL = `https://uat-mailback.tes-amm.com`
}
else if (env === ENV_TYPES.PRODUCTION) {
    _CURRENT_ENV = 'PROD';
    _ADMIN_SERVIE_URL = `${API_URL}/cpadmin`
    _AUTH_SERVICE_URL = `${API_URL}/auth`
    _APP_URL = `https://customer-portal.tes-amm.com`
}
export const CURRENT_ENV = _CURRENT_ENV;
export const ADMIN_SERVIE_URL = _ADMIN_SERVIE_URL
export const ADMIN_SYNC_URL = _ADMIN_SYNC_URL
export const AUTH_SERVICE_URL = _AUTH_SERVICE_URL
export const API_LISTS = API_REQUESTS
export const APP_URL = _APP_URL
export const B2C_URL = _B2C_URL
export const B2C_CUSTOMER_URL = _B2C_CUSTOMER_URL
export const B2C_API_LISTS = B2C_API_REQUESTS

export const VALIDATE_REGEX = {
    // email: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
    email: /[a-zA-Z0-9._]*@[a-zA-Z0-9.-]*\.[a-z]*/,
    phone: /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im
}

export const ICONS_LIST = [
{
    name: "Box Icon",
    value: "tes-box"
},
{
    name: "Questionanaire List",
    value: "tes-questionnaire-list"
},
{
    name: "Delivery Truck Icon",
    value: "tes-delivery-truck"
},  
{
    name: "Tes Calendar Icon",
    value: "tes-calander"
},
{
    name: "Schedule",
    value: "tesStatusIconsSchedule",
    path: 27
},
{
    name: "Reporting Done",
    value: "tesStatusIconsReportingDone",
    path: 8
},
{
    name: "Processing Done",
    value: "tesStatusIconsprocess",
    path: 17
},
{
    name: "Reached Facility",
    value: "tesStatusIconsFacility",
    path: 13
},
{
    name: "Completed",
    value: "tesStatusIconsComplete",
    path: 8
},
{
    name: "Approve",
    value: "tesStatusIconsApproved",
    path: 14
},
{
    name: "Cancel",
    value: "tesStatusIconsCancel",
    path: 14
},
{
    name: "New",
    value: "tesStatusIconsNew",
    path: 14
},
{
    name: "Donation Sent",
    value: "tesStatusIconsDonationSent",
    path: 30
},
{
    name: "COD Completed",
    value: "tesStatusIconsCodDone",
    path: 14
},
{
    name: "Quote Requested",
    value: "tesStatusIconsQuoteRequested",
    path: 14
},
{
    name: "Quote Sent",
    value: "tesStatusIconsQuoteSent",
    path: 15
},
{
    name: "Quote Accepted",
    value: "tesStatusIconsQuoteAccepted",
    path: 14
},
{
    name: "Quote Declined",
    value: "tesStatusIconsQuoteDeclined",
    path: 14
},
]

export const REPORT_MODULE_NAMES = [
    {
        displayName: 'Reports Display',
        name: 'Reports Display'
    },
    {
        displayName: 'Reports Search',
        name: 'Reports Search'
    },
    {
        displayName: 'Reception Reports',
        name: 'Reception Reports'
    },
    {
        displayName: 'Booking Reports',
        name: 'Booking Reports'
    },
    {
        displayName: 'Value Back Reports',
        name: 'Value Back Reports'
    },
    {
        displayName: 'Revenue Share Reports',
        name: 'Revenue Share Reports'
    },
    {
        displayName: 'ServiceFee booking Reports',
        name: 'ServiceFee booking Reports'
    },
    {
        displayName: 'Miscellaneous Reports',
        name: 'Miscellaneous Reports'
    },
    {
        displayName: 'Settlement Reports',
        name: 'Settlement Reports'
    },
    {
        displayName: 'Portal Docs',
        name: 'Portal Docs'
    },
    {
      displayName: 'Recycling Reception Reports',
      name: 'Recycling Reception Reports'
    },
    {
      displayName: 'Audit/Booking Report',
      name: 'Audit/Booking Report'
    },
    {
        displayName: 'Reconciliation Report',
        name: 'Reconciliation Report'
    }
]

export const Service_Types = {
    Standard: "Standard",
    Extra: "Extra"
}

export const SELECT_TYPES = [
    { value: null, label: '' },
    { value: null, label: '--Scan or Enter Tracking ID--' },
    { value: null, label: '' }
]


export const B2C_REPORT_TYPES = [
    { value: 1, label: 'Request Reports' },
    { value: 2, label: 'Reception Reports' }
]

/* stage which the default will be QR_CODE_USER */
export const STAGES_DEFAULT_QR_CODE_USER = [
    { name: "Asset Images", matchkey: "asset_image" },
    { name: "Asset Details", matchkey: "asset-details" }
]

/* stage which the default will be QR_CODE_GENERATOR */
export const STAGES_DEFAULT_QR_CODE_GENERATOR = [
    { name: "TES Services", matchkey: "service-detail" },
    { name: "Request Details", matchkey: "request-detail" },
]